import "./tris.css";
import { useState, useEffect } from "react";
import DefaultButton from "../DefaultButton";
import { BsArrowCounterclockwise } from "react-icons/bs";
import ghost from "./ghost.png";
import x from "./x.png";
import o from "./o.png";

const WINNING_COMBINATIONS = [
  [0,1,2],
  [3,4,5],
  [6,7,8],
  [0,3,6],
  [1,4,7],
  [2,5,8],
  [0,4,8],
  [2,4,6]
];

export default function TrisGame() {
    const [board, setBoard] = useState(Array(9).fill(null));
    const [winner, setWinner] = useState(null);    
    const playerWon = winner === "X";
    const computerWon = winner === "O";
    // const gameOver = winner !== null;
    // const draw = winner === "draw";

    const draw =
        winner === null &&
        board.every(cell => cell !== null);

    const gameOver =
        playerWon ||
        computerWon ||
        draw;

    useEffect(() => {
    // crea stato nella history
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
        // reset gioco
        console.log("Pop state detected, resetting game");
        resetGame();

        // blocca uscita e rimetti la pagina immediatamente
        window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
        window.removeEventListener("popstate", handlePopState);
    };
    }, []);
        
    function getWinner(cells) {
        for (const [a,b,c] of WINNING_COMBINATIONS) {
            if (
                cells[a] &&
                cells[a] === cells[b] &&
                cells[a] === cells[c]
            ) {
                return cells[a];
            }
        }
        return null;
    }

    function handleClick(index) {
        if (board[index] || gameOver) return;

        const newBoard = [...board];
        newBoard[index] = "X";

        const win = getWinner(newBoard);
    
        setBoard(newBoard);

        // X vince
        if (win) {
            setWinner("X");
            return;
        }
        // pareggio / nessun vincitore
        if (newBoard.every(cell => cell !== null)) {
            return;
        }

        setTimeout(() => {
            computerMove(newBoard);
        }, 400);
    }

    function computerMove(currentBoard) {
        if (gameOver) return;

        const empty = currentBoard
            .map((c, i) => (c === null ? i : null))
            .filter(v => v !== null);

        if (!empty.length) return;

        const move = empty[Math.floor(Math.random() * empty.length)];

        const newBoard = [...currentBoard];
        newBoard[move] = "O";

        const win = getWinner(newBoard);

        setBoard(newBoard);

        if (win) {
            setWinner("O");
            return;
        }
    }

    function resetGame() {
        setBoard(Array(9).fill(null));
        setWinner(null);
    }

    return (
        <div className="h-full flex flex-col items-center justify-center text-white gap-6 w-full">
            {!playerWon && !computerWon && !draw && (
                <p className="mb-6">✨ Ma hai trovato un gioco! ✨</p>
            )}

            {playerWon && (
                <div className="bubble-speech">
                    <p className="text-center px-2">
                    Hai vinto! 🎉<br/>
                    Te si sta brao.
                    </p>
                </div>
            )}

            {computerWon && (
                <div className="bubble-speech">
                    <p className="text-center px-2">
                    Hai perso! 😈<br/>
                    Che scarso
                    </p>
                </div>
            )}

            {draw && (
                <div className="bubble-speech mb-3">
                    <p className="text-center px-2">
                    Nessun vincitore 🙅‍♀️
                    </p>
                </div>
            )}

            <div className="relative mt-8">
                <img src={ghost} alt="mascotte" className="w-20 absolute bottom-full right-5 bouncing-animation" />

                <div className="grid-tris">
                    {board.map((cell,index) => (
                        <button
                            key={index}
                            className="cell-tris"
                            onClick={() => handleClick(index)}>
                            {cell === "X" && <img src={x} alt="X" className="w-9 h-9" />}
                            {cell === "O" && <img src={o} alt="O" className="w-10 h-10" />}
                        </button>
                    ))}
                </div>
            </div>

            <div className="flex flex-col gap-10 items-center w-2/3 xl:w-1/2">
                <button onClick={resetGame} 
                className="inline-flex items-center gap-2 w-fit uppercase panoragraf-light tracking-wider rounded-full 
                border border-red-500 text-red-500 px-8 py-2 hover:bg-red-500 hover:text-white transition-all duration-300">
                    rigioca
                    <BsArrowCounterclockwise size={20} />
                </button>

                {playerWon && (
                    <DefaultButton text="Torna alla home" link="/" />
                )}
            </div>

        </div>
    );
}